//changed due to package upgrade
/* eslint-disable */
import AppsHeader from '@projectK/components/AppsHeader';
import {
  alpha,
  Box,
  Grid,
  useMediaQuery,
  useTheme,
  Button,
  FormControl,
  Select,
  MenuItem,
  Typography,
  IconButton,
} from '@mui/material';
import React, { useEffect, useState,useRef } from 'react';
import { useIntl } from 'react-intl';
import AppsContent from '@projectK/components/AppsContent';
import AppsPagination from '@projectK/components/AppsPagination';
import {
  WaiversLogTable,
  WaiversLogFilter,
} from '@projectK/modules/Admin/ProductWaiversLog';
import AppInfoView from '@projectK/components/AppInfoView';
import { Fonts } from '@projectK/constants/AppEnums';
import jwtAxios from '@projectK/services/auth/JWT';
import AppsContainer from '@projectK/components/AppsContainer';
import { useApplicationSettings } from '@projectK/context/VerbiageContextProvider';
import {
  FileDownloadOutlined as FileDownloadOutlinedIcon,
  UnfoldMoreOutlined,
} from '@mui/icons-material';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import { mobileExportCsv } from '@projectK/ReUseFunctions';
import {
  SearchFieldMain,
  SortingModalWaiverMain,
} from '../../../../../../libs/MainComponents';
import {
  useRolePermissions,
  hasPermission,
} from '@projectK/context/RolesProvider';
import PropTypes from 'prop-types';

const ButtonWithStyles = ({ children, onClick, sxProps }) => (
  <Button
    variant='outlined'
    size='medium'
    color='primary'
    onClick={onClick}
    sx={{
      position: 'relative',
      ml: 2.5,
      minWidth: 100,
      borderColor: sxProps.borderColor,
      '&:hover': {
        borderColor: alpha(sxProps.borderColor, 0.8),
      },
      color: sxProps.color,
      textTransform: 'none',
      ...sxProps.additionalStyles,
    }}
  >
    {children}
  </Button>
);

ButtonWithStyles.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  sxProps: PropTypes.object,
};

const StudentWaiversLog = () => {
  const isMobileResponse = useMediaQuery('(max-width:755px)');
  const { isMobile } = useMobileSettings();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const { verbiageSettings } = useApplicationSettings();
  const companyTheme = CompanyTheme();
  const { messages } = useIntl();
  const [page, setPage] = useState(0);
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [perPage, setPerPage] = useState(20);
  const [titleSorting, setTitleSorting] = useState(null);
  const [descriptionSorting, setDescriptionSorting] = useState(null);
  const [productSorting, setProductSorting] = useState(null);
  const [userSorting, setUserSorting] = useState(null);
  const [dateSorting, setDateSorting] = useState(null);
  const [productFilter, setProductFilter] = useState('');
  const [userFilter, setUserFilter] = useState('');
  const [signedDateFilter, setSignedDateFilter] = useState('');
  const [openSortingModal, setOpenSortingModal] = useState(false);
  const { rolePermissions } = useRolePermissions();
  const abortControllerRef = useRef(null);
  const [exportLoading, setExportLoading] = useState(false);

  const { user } = useAuthUser();
  const handleChangePerPage = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(0);
  };

  const onSearchCustomer = (e) => {
    setSearch(e.target.value);
    setPage(0);
  };
  const onPageChange = (event, value) => {
    setPage(value);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      abortControllerRef.current = new AbortController();
      const { signal } = abortControllerRef.current;
      const response = await jwtAxios.get(
        `product-waiver-settings/student/signed/${user?.id}`,
        {
          params: {
            search,
            page,
            perPage,
            filters: {
              productId: productFilter,
              created_at: signedDateFilter,
            },
            sortings: {
              waiver_name: titleSorting,
              description: descriptionSorting,
              product_name: productSorting,
              user_name: userSorting,
              created_at: dateSorting,
            },
          },
          signal,
        },
      );
      const { data } = response;
      setList(data.list);
      setTotal(data.total);
      data.list.length === 0 && page > 0 && setPage(page - 1);
      setLoading(false);
    } catch (error) {
      if (error.message !== 'canceled') {
          console.error('An error occurred:', error);
          setLoading(false);
      }
    }
  };
  useEffect(() => {
    fetchData();
   return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [
    user?.id,
    search,
    page,
    perPage,
    productFilter,
    signedDateFilter,
    titleSorting,
    descriptionSorting,
    productSorting,
    userSorting,
    dateSorting,
  ]);

  const handleExportCSV = async () => {
    try {
      setExportLoading(true);
      const response = await jwtAxios.get(
        `/product-waiver-settings/student/export/${user?.id}`,
        {
          params: {
            search,
            filters: {
              productId: productFilter,
              created_at: signedDateFilter,
            },
            sortings: {
              waiver_name: titleSorting,
              description: descriptionSorting,
              product_name: productSorting,
              user_name: userSorting,
              created_at: dateSorting,
            },
          },
          responseType: 'arraybuffer',
        },
      );
      const blob = new Blob([response.data], { type: `application/csv` });
      if (isMobile) {
        await mobileExportCsv(blob, 'waivers_log', 'csv');
      } else {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Waivers_log.csv';
        link.click();
        setExportLoading(false);
      }
    } catch (error) {
      console.error('An error occurred:', error);
      setExportLoading(false);
    }
  };
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const handleFilterModalOpen = () => {
    setOpenFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setOpenFilterModal(false);
  };
  const handleClearFilter = () => {
    setTitleSorting(null);
    setDescriptionSorting(null);
    setProductSorting(null);
    setUserSorting(null);
    setDateSorting(null);
  };
  return (
    <>
      <WaiversLogFilter
        productFilter={productFilter}
        userFilter={userFilter}
        signedDateFilter={signedDateFilter}
        setProductFilter={setProductFilter}
        setUserFilter={setUserFilter}
        setSignedDateFilter={setSignedDateFilter}
        verbiageSettings={verbiageSettings}
        setPage={setPage}
        isMobile={isMobile}
        openFilterModal={openFilterModal}
        handleFilterModalClose={handleFilterModalClose}
      />
      <br></br>

      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          width: 1,
          justifyContent: 'space-between',
        }}
      >
        <Typography
          variant='h4'
          className='mt-15'
          sx={{
            color: companyTheme ? companyTheme.primary.main : 'text.primary',
            fontWeight: Fonts.SEMI_BOLD,
          }}
        >
          {`${verbiageSettings?.product_type || 'Product'} ${
            verbiageSettings?.waiver_name_plural || 'Waivers'
          } Log`}
        </Typography>
        {isMobile && (
          <>
            <Box onClick={handleFilterModalOpen} className='mt-15'>
              <span>Filters</span>
              <IconButton
                size='small'
                sx={{ fontWeight: 'bold' }}
                className='icon-btn'
              >
                <FilterListIcon />
              </IconButton>
            </Box>
            <Box onClick={() => setOpenSortingModal(true)} className='mt-15'>
              <span>Sort</span>
              <IconButton
                size='small'
                sx={{ fontWeight: 'bold' }}
                className='icon-btn'
              >
                <UnfoldMoreOutlined />
              </IconButton>
            </Box>
          </>
        )}
      </Grid>
      <div className='event-search ps-h'>
        <AppsContainer fullView>
          <AppsHeader>
            <Box
              display='flex'
              flexDirection='row'
              alignItems='center'
              width={1}
              justifyContent='space-between'
              className='main-box'
            >
              <Box display='flex' flexDirection='row' className='search-box'>
                <SearchFieldMain
                  iconPosition='right'
                  overlap={false}
                  onChange={onSearchCustomer}
                  placeholder={messages['common.searchHere']}
                />
              </Box>
              <Box
                display='flex'
                flexDirection='row'
                alignItems='center'
                className='button-boxes'
              >
                {!isMobile &&
                  hasPermission(
                    rolePermissions,
                    'Product Waivers Log',
                    'export',
                  ) && (
                    <ButtonWithStyles
                      className='down-btn'
                      onClick={handleExportCSV}
                      sxProps={{
                        borderColor: companyTheme
                          ? companyTheme.primary.main
                          : '#2196f3',
                        color: companyTheme
                          ? companyTheme.primary.main
                          : '#2196f3',
                      }}
                    >
                      {isMobileResponse ? (
                        <FileDownloadOutlinedIcon sx={{ mr: 1 }} />
                      ) : (
                        <>
                          {' '}
                          <FileDownloadOutlinedIcon sx={{ mr: 1 }} /> Export as
                          CSV{' '}
                        </>
                      )}
                    </ButtonWithStyles>
                  )}
                {!isSmDown && (
                  <>
                    {' '}
                    <FormControl
                      variant='standard'
                      sx={{
                        borderRadius: 50,
                      }}
                      size='small'
                    >
                      <Select
                        value={perPage}
                        onChange={handleChangePerPage}
                        sx={{ marginLeft: '10px' }}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={30}>30</MenuItem>
                        <MenuItem value={40}>40</MenuItem>
                        <MenuItem value={60}>60</MenuItem>
                        <MenuItem value={80}>80</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                    <AppsPagination
                      rowsPerPage={perPage}
                      count={total}
                      page={page}
                      onPageChange={onPageChange}
                    />
                  </>
                )}
              </Box>
            </Box>
          </AppsHeader>
          <AppsContent
            className='evnt-s-table ps-events'
            sx={{
              paddingTop: 2.5,
              paddingBottom: 2.5,
            }}
          >
            {openSortingModal && (
              <SortingModalWaiverMain
                isOpen={openSortingModal}
                onClose={() => setOpenSortingModal(false)}
                clearFilter={handleClearFilter}
                sortings={{
                  titleSorting,
                  setTitleSorting,
                  descriptionSorting,
                  setDescriptionSorting,
                  productSorting,
                  setProductSorting,
                  userSorting,
                  setUserSorting,
                  dateSorting,
                  setDateSorting,
                }}
                companyTheme={companyTheme}
              />
            )}
            <WaiversLogTable
              waiversLogData={list}
              loading={loading}
              fetchData={fetchData}
              verbiageSettings={verbiageSettings}
              titleSorting={titleSorting}
              descriptionSorting={descriptionSorting}
              productSorting={productSorting}
              userSorting={userSorting}
              dateSorting={dateSorting}
              setTitleSorting={setTitleSorting}
              setDescriptionSorting={setDescriptionSorting}
              setProductSorting={setProductSorting}
              setUserSorting={setUserSorting}
              setDateSorting={setDateSorting}
              exportLoading={exportLoading}
            />
          </AppsContent>
          {!isSmUp && (
            <>
              {' '}
              <FormControl
                variant='standard'
                sx={{
                  borderRadius: 50,
                }}
                size='small'
                className='cols-count colc25'
              >
                <Select
                  value={perPage}
                  onChange={handleChangePerPage}
                  sx={{ marginLeft: '10px', height: '34px' }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={30}>30</MenuItem>
                  <MenuItem value={40}>40</MenuItem>
                  <MenuItem value={60}>60</MenuItem>
                  <MenuItem value={80}>80</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
              <AppsPagination
                className='cols-pagination'
                rowsPerPage={perPage}
                count={total}
                page={page}
                onPageChange={onPageChange}
              />
            </>
          )}
        </AppsContainer>
        <AppInfoView />
      </div>
    </>
  );
};

export default StudentWaiversLog;
